var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"entity-types-images/time","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M48,27 L48,27 C48,38.5979797 38.5979797,48 27,48 L27,48 C15.4020203,48 6,38.5979797 6,27 L6,27 C6,15.4020203 15.4020203,6 27,6 L27,6 C38.5979797,6 48,15.4020203 48,27 Z","id":"Rectangle-314","stroke":"#333333","strokeWidth":"2","fill":"#FFFFFF","key":0}),React.createElement("polyline",{"id":"Path-2","stroke":"#333333","strokeWidth":"2","points":"27.3375789 13.0997312 27.3375789 28.5748487 33.5924964 34.8297661","key":1})])]);
}

Time.defaultProps = {"width":"54px","height":"54px","viewBox":"0 0 54 54","version":"1.1"};

module.exports = Time;

Time.default = Time;
